import React, { useState, useEffect } from "react";
import { useOutletContext, useParams } from "react-router";
import { getLeagueBySlug } from "../components/leagueLocker/firestoreQuery";
import { LeagueContext } from "./LeagueLockerPage";
import { SectionLoader } from "../components/ui/SectionLoader";

const LeagueLockerMerchSection = () => {
  //const { leagueUrl } = useParams();
  const { leagueUrl } = useOutletContext<LeagueContext>();
  // const leagueSlug = leagueUrl;
  const [leagueData, setLeagueData] = useState<any>({});
  const [isLoading, setIsLoading] = useState(true);

  const fetchLeagueDetails = async () => {
    try {
      // Fetch league details logic here
      setIsLoading(true);
      const res = await getLeagueBySlug(leagueUrl || "");
      setLeagueData(res);
    } catch (error) {
      console.error("Error fetching league:", error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchLeagueDetails();
  }, [leagueUrl]);

  if (isLoading) {
    return (
      <div className="flex justify-center items-center h-32">
        <SectionLoader />
      </div>
    );
  }
  return (
    <div>
      <ul className="marchItemList">
        {leagueData?.merchandise && leagueData.merchandise.length > 0 ? (
          [...leagueData.merchandise]
            .sort((a, b) => (a.displayOrder ?? 0) - (b.displayOrder ?? 0))
            .map((merch: any) => {
              return (
                <li key={merch.productId}>
                  <div className="itemPic">
                    <img
                      src={merch.productImage ?? ""}
                      alt={merch.productTitle ?? `product-${merch.productId}`}
                    />
                  </div>
                  <div className="itemHeading">{merch.productTitle}</div>
                  <div className="itemActions">
                    <button
                      className="btnStyle btnFilled"
                      type="button"
                      onClick={() => {
                        window.open(merch.productUrl, "_blank");
                      }}
                    >
                      BUY
                    </button>
                  </div>
                </li>
              );
            })
        ) : (
          <li>
            <div className="itemHeading">No products added yet</div>
          </li>
        )}
      </ul>
    </div>
  );
};

export default LeagueLockerMerchSection;
